import { render } from "./AppointmentConfigList.vue?vue&type=template&id=84ba339e"
import script from "./AppointmentConfigList.vue?vue&type=script&lang=js"
export * from "./AppointmentConfigList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__